// Each member's own data about an item (phase 3 §2): my rating (0.5 to 5
// by halves), "seen" — or read, played… the type's verb — with its date,
// and a private note; the members' average beside them. The type decides
// what is tracked (item_types[].personal, the model's default otherwise).

export const VERBS = ['seen', 'read', 'played', 'listened', 'used'];

/** A type's tracking settings: {done: verb | null, rating: bool}. */
export const personalOf = (type) => {
  const personal = type && type.personal;
  if (personal && typeof personal === 'object') {
    return { done: VERBS.includes(personal.done) ? personal.done : null, rating: personal.rating !== false };
  }
  return { done: null, rating: true };
};

/** What the collection's types track, together: any rating, the verbs used. */
export const collectionPersonal = (types) => {
  const all = (types || []).map(personalOf);
  return {
    rating: all.some((p) => p.rating),
    verbs: [...new Set(all.map((p) => p.done).filter(Boolean))],
  };
};

/** True when someone besides the owner may rate: an average then means something. */
export const isShared = (inventory) => Number(inventory && inventory.member_count) > 1;

/** A number in the reader's language, one decimal at most ("4,5"). */
export const starNumber = (value, lang) => new Intl.NumberFormat(lang, { maximumFractionDigits: 1 }).format(value);

/** Today in the browser's calendar, as YYYY-MM-DD. */
export const today = () => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};
